var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$refs.upload && _vm.$refs.upload.dropActive,
            expression: "$refs.upload && $refs.upload.dropActive"
          }
        ],
        staticClass: "drop-active"
      },
      [_c("h3", [_vm._v("Suelta el archivo para subir")])]
    ),
    _c(
      "div",
      { staticClass: "cursor-pointer" },
      [
        _c("file-upload", {
          ref: "upload",
          staticClass: "file-upload",
          attrs: { drop: true, drag: true, multiple: false },
          model: {
            value: _vm.files,
            callback: function($$v) {
              _vm.files = $$v
            },
            expression: "files"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }